"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service pro práci s typy dokumentu. Generated from cz.marbes.api.dokument.v1.TypDokumentService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:38:53Z                      #

// ##############################################################

var TypDokumentApi = function () {
  function TypDokumentApi() {
    (0, _classCallCheck3.default)(this, TypDokumentApi);
  }

  (0, _createClass3.default)(TypDokumentApi, null, [{
    key: "getSablonyProTypDokumentu",

    /**
     * Vrací kolekci šablon navázaných na typ dokumentu.
     *
     * @param kodTypDokument 
     * @return šablony navázané na typ dokumentu
     */
    value: function getSablonyProTypDokumentu(kodTypDokument) {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/sablony";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrací typ dokumentu s předanýcm kódem.
     *
     * @param kodTypDokument kód typu dokumentu
     * @return {@link TypDokument}
     */

  }, {
    key: "getTypDokumentByKod",
    value: function getTypDokumentByKod(kodTypDokument) {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrací všechny typy dokumentů seřazené dle {@link TypDokument#getNazev()}.
     *
     * @return typy dokumentů
     */

  }, {
    key: "findTypyDokumentu",
    value: function findTypyDokumentu() {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Konfigurace typu dokumentu. Pokud neexistuje typ dokumentu s předaným kódem, založí ho. Pokud typ dokumentu existuje, vrací uložený záznam.
     *
     * @param kodTypDokument 
     * @param nazevDokument 
     * @return založeny typ dokumentu
     */

  }, {
    key: "createTypDokument",
    value: function createTypDokument(kodTypDokument, nazevDokument) {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/create";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument, nazevDokument: nazevDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Smaže typ dokumentu s daným kódem.
     *
     * @param typDokumentKod kód typu dokumentu
     */

  }, {
    key: "deleteTypDokument",
    value: function deleteTypDokument(typDokumentKod) {
      var uri = serverContextPath + ("/api/dokumenty/v1/typy/dokumentu/" + typDokumentKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.delete(uri, params));
    }

    /**
     * Dohledání typů dokumentu dle seznamu předaných kódů.
     *
     * @param kodTypDokuments seznam kódů typu dokumentu
     * @return seznam dohledaných typů dokumentu
     */

  }, {
    key: "getTypyDokumentu",
    value: function getTypyDokumentu(kodTypDokuments) {
      var uri = serverContextPath + "/api/dokumenty/v1/typy/dokumentu/batchRequest";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, kodTypDokuments, headers));
    }

    /**
     * Aktualizace existujícího typu dokumentu.
     *
     * @param typDokumentKod kód typu dokumentu
     * @param typDokument 
     * @return aktualizovaný typ dokument
     */

  }, {
    key: "updateTypDokument",
    value: function updateTypDokument(typDokumentKod, typDokument) {
      var uri = serverContextPath + ("/api/dokumenty/v1/typy/dokumentu/" + typDokumentKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, UpdateMethods.updateTypDokument_8E5AECv1(typDokument), headers));
    }
  }]);
  return TypDokumentApi;
}();

exports.default = TypDokumentApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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